// components/layout/StudentsProfile.js
import React from "react";
import { Box, Container } from '@mui/material';
import Grid from '@mui/system/Grid';
import "../../style/pages/_studentDashboard.scss"

const StudentsProfile = ({ studentsData, onLogout }) => {
      const { fullname, email, mobile, board, grade, gender } = studentsData || {};
   
   
    return(
        <>
             <div className='dashboard parentdiv dashboard-container'>
                <div className="user-info-container">
                    <h2 className="profile-title">Your Profile</h2>
                    <div className="user-info">
                        <div className="info-item">
                            <span className="label">Full Name</span>
                            <span className="value">{fullname || 'Not provided'}</span>
                        </div>
                        <div className="info-item">
                            <span className="label">Email</span>
                            <span className="value">{email || 'Not provided'}</span>
                        </div>
                        <div className="info-item">
                            <span className="label">Mobile</span>
                            <span className="value">{mobile || 'Not provided'}</span>
                        </div>
                        <div className="info-item">
                            <span className="label">Board</span>
                            <span className="value">{board || 'Not provided'}</span>
                        </div>
                        <div className="info-item">
                            <span className="label">Grade</span>
                            <span className="value">{grade || 'Not provided'}</span>
                        </div>
                        <div className="info-item">
                            <span className="label">Gender</span>
                            <span className="value">{gender || 'Not provided'}</span>
                        </div>
                    </div>
                </div> 
            </div>
        </>
    )
}
export { StudentsProfile }

